import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsHappeninginline = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M0 0l32.174 14L64 0v30L32.254 16 0 30z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 3v8m40-8v8",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3 17h58",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 7h50a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(0 23)",
				children: [
					/* @__PURE__ */ _jsx("mask", {
						id: "b",
						fill: "#fff",
						children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
					}),
					/* @__PURE__ */ _jsx("circle", {
						stroke: "currentColor",
						strokeWidth: 2,
						strokeLinecap: "square",
						strokeLinejoin: "round",
						mask: "url(#b)",
						cx: 32,
						cy: 15,
						r: 17
					}),
					/* @__PURE__ */ _jsx("circle", {
						stroke: "currentColor",
						strokeWidth: 2,
						strokeLinecap: "square",
						strokeLinejoin: "round",
						mask: "url(#b)",
						cx: 32,
						cy: 15,
						r: 23
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				d: "M32 41.36l-7.053 5.148 2.716-8.299-7.076-5.117 8.733.019L32 24.8l2.68 8.31 8.733-.018-7.076 5.117 2.716 8.3z"
			})
		]
	})]
});
export default SvgWhatsHappeninginline;
